import React from 'react'

import { ConfirmationModal } from '@acorns/web-components'
import { noop } from 'lodash'

import WarningIcon from 'assets/icons/warning-icon-black-with-gray-circle.svg'

export function SessionAboutToExpireModal() {
  return (
    <ConfirmationModal
      isOpen={true}
      onRequestClose={noop}
      image={WarningIcon}
      title="Are You Still There?"
      message="You are about to be logged out due to inactivity."
    />
  )
}
